<script setup lang="ts">
import { computed } from 'vue'

import SettingImageSelector from '@/components/beta-editor/settings/controls/BetaSettingImageSelector.vue'
import SettingOpacity from '@/components/atoms/SettingOpacity.vue'
import BetaSettingColorPicker from '@/components/beta-editor/settings/controls/BetaSettingColorPicker.vue'
import { useEditorBetaStore } from '@/stores/editor/beta'
import { useLayoutStore } from '@/stores/layout'

const betaStore = useEditorBetaStore()
const layoutStore = useLayoutStore()

const sectionForEdit = computed(() => betaStore.sectionForEdit)
const defaultBackgroundColor = computed(() => (
    layoutStore.getSectionBackgroundColorDefault(sectionForEdit.value?.sectionIndex ?? 0) ?? ''
))
const backgroundColor = computed(() => (
    sectionForEdit.value?.extra?.background_color || defaultBackgroundColor.value
))
const backgroundImage = computed(() => sectionForEdit.value?.backgroundImage ?? null)
const backgroundImageOpacity = computed(() => sectionForEdit.value?.extra?.background_image_opacity ?? '80')
const backgroundFocalPoint = computed(() => (
    sectionForEdit.value?.extra?.background_image_focal_point ?? { x: 50, y: 50 }
))

const onChangeBackgroundColor = (color: string) => {
    if (!sectionForEdit.value) return

    betaStore.updateSectionExtra({
        ...sectionForEdit.value.extra,
        background_color: color === defaultBackgroundColor.value ? '' : color,
    })
}

const onChangeImageSelector = (event: any) => {
    if (!sectionForEdit.value) return

    if (event.target === 'image') {
        if (!event.value) {
            betaStore.setBackgroundImageSectionForEdit(null)
            return
        }

        betaStore.setBackgroundImageSectionForEdit({
            id: event.value.id,
            uri: event.value.content,
            width: event.value.width,
            height: event.value.height,
        })
        return
    }

    if (event.target === 'focal-point') {
        betaStore.updateSectionExtra({
            ...sectionForEdit.value.extra,
            background_image_focal_point: event.value,
        })
    }
}

const onChangeBackgroundImageOpacity = (opacity: number) => {
    if (!sectionForEdit.value) return

    betaStore.updateSectionExtra({
        ...sectionForEdit.value.extra,
        background_image_opacity: opacity,
    })
}
</script>

<template>
    <div v-if="sectionForEdit" class="beta-settings-panel">
        <h2>Seção</h2>

        <beta-setting-color-picker
            label="Cor de Fundo"
            :value="backgroundColor"
            :default-value="defaultBackgroundColor"
            clear-on-default
            @change="onChangeBackgroundColor"
        />

        <setting-image-selector
            label="Imagem de Fundo"
            :value="backgroundImage?.uri"
            with-focal-point
            with-remove
            :focal-point="backgroundFocalPoint"
            @change="onChangeImageSelector"
        />

        <setting-opacity
            v-if="backgroundImage"
            label="Opacidade da imagem"
            :value="backgroundImageOpacity"
            @change="onChangeBackgroundImageOpacity"
        />
    </div>
</template>

<style scoped>
.beta-settings-panel {
    @apply flex w-full flex-col gap-6;
}

.beta-settings-panel h2 {
    @apply text-base font-bold text-[#10233E];
}
</style>
